import type { LucideIcon } from 'lucide-react';

export function BotonDeFila({
  icono: Icono,
  titulo,
  alPulsar,
  ocupado,
}: {
  icono: LucideIcon;
  titulo: string;
  alPulsar: () => void;
  ocupado?: boolean | undefined;
}) {
  return (
    <button
      type="button"
      onClick={alPulsar}
      disabled={ocupado}
      title={titulo}
      aria-label={titulo}
      className="grid size-8 place-items-center rounded-lg text-armazon-400 transition-colors hover:bg-armazon-100 hover:text-armazon-700 disabled:opacity-50"
    >
      <Icono className="size-4" aria-hidden />
    </button>
  );
}
